<template>
  <!-- D: 검색내역 -->
  <ul class="search-result-list">
    <ItemRow
      v-for="item in keywords"
      :key="item.srchHistSn"
      :item="item"
      @delete="deleteAgencySrchHist"
      @select="(item) => emits('select', item.shwrd)"
    />
  </ul>

  <!-- D: MO 전용 -->
  <div v-if="keywords.length > 0" class="mo-btn-area only-mo">
    <button
      type="button"
      class="c-button type-line-white type-small"
      @click="deleteAgencySrchHistAll"
    >
      <span>전체 삭제</span>
    </button>
  </div>

  <!-- D: 검색어가 없을 경우 -->
  <div v-show="keywords.length === 0" class="search-nodata">
    <p class="text">최근 검색어가 없습니다.</p>
  </div>

  <!-- D: PC 전용 -->
  <button
    v-if="keywords.length > 0"
    type="button"
    class="c-button type-line-white type-small only-pc"
    @click="deleteAgencySrchHistAll"
  >
    <span>전체 삭제</span>
  </button>
</template>
<script setup>
import { onMounted, ref, inject, defineEmits } from "vue";
import { api } from "@/plugins/api";
import ItemRow from "@/components/paintpro/prod/recentSearchesContRow.vue";
import * as cmUtil from "@/utils/cmUtil.js";

const emits = defineEmits(["select"]);

const url = inject("url_prefix");

const keywords = ref([]);

onMounted(() => {
  loadLatestKeyowrds();
});

const loadLatestKeyowrds = async () => {
  const res = await api.get(`${url}/agency/search/latestKeywords`);

  const { resultCode } = res;
  if (resultCode !== 200) {
    //alert(`errror : resultCode:${resultCode}, message:${message} `);
    return;
  }

  keywords.value = res.data;
};

const deleteAgencySrchHist = async (item) => {
  // const res = await api.post(
  //   `${url}/agency/search/agency-srch-hist/${item.srchHistSn}/delete`
  // );

  const res = await api.post(`${url}/agency/search/agency-srch-hist/delete`, {
    shwrd: item.shwrd,
  });

  const { resultCode } = res;
  if (resultCode !== 200) {
    //alert(`errror : resultCode:${resultCode}, message:${message} `);
    return;
  }

  loadLatestKeyowrds();
};

const deleteAgencySrchHistAll = async () => {
  if (!(await cmUtil.confirm("전체 최근 검색어를 삭제하시겠습니까?"))) {
    return false;
  }
  const res = await api.post(
    `${url}/agency/search/agency-srch-hist/delete-all`
  );

  const { resultCode } = res;
  if (resultCode !== 200) {
    //alert(`errror : resultCode:${resultCode}, message:${message} `);
    return;
  }
  loadLatestKeyowrds();
};
</script>
